import { render, staticRenderFns } from "./Screening.vue?vue&type=template&id=4eb87fae&scoped=true&"
import script from "./Screening.vue?vue&type=script&lang=js&"
export * from "./Screening.vue?vue&type=script&lang=js&"
import style0 from "./Screening.vue?vue&type=style&index=0&id=4eb87fae&prod&lang=scss&scoped=true&"
import style1 from "./Screening.vue?vue&type=style&index=1&id=4eb87fae&prod&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4eb87fae",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {AeqDocumentList: require('/home/vsts/work/1/s/components/AeqDocumentList.vue').default,AeqFileField: require('/home/vsts/work/1/s/components/AeqFileField.vue').default,ErrorHandlerScreening: require('/home/vsts/work/1/s/components/ErrorHandlerScreening.vue').default,AeqInfoBox: require('/home/vsts/work/1/s/components/AeqInfoBox.vue').default,Step: require('/home/vsts/work/1/s/components/Step.vue').default})
